import { useLayoutEffect } from 'react';
import './fonts.css';
import './student-brand.css';

// The HTML shell is shared with administration. Restore it when leaving
// the student route, including during React StrictMode's effect replay.
export default function StudentBrand({ children }) {
  useLayoutEffect(() => {
    const restore = [];
    const setAttribute = (element, name, value) => {
      if (!element) return;
      const previous = element.getAttribute(name);
      element.setAttribute(name, value);
      restore.push(() => previous === null
        ? element.removeAttribute(name)
        : element.setAttribute(name, previous));
    };

    document.body.classList.add('ices-student');
    setAttribute(document.querySelector('.header-logo'), 'src', '/brand/ices/logo-institut-inverse.png');
    setAttribute(document.querySelector('.header-logo'), 'alt', 'ICES — Institut catholique de Vendée');
    setAttribute(document.querySelector('link[rel="icon"]'), 'href', '/brand/ices/favicon-badgeuse.png');
    setAttribute(document.querySelector('link[rel="apple-touch-icon"]'), 'href', '/brand/ices/favicon-badgeuse.png');
    setAttribute(document.querySelector('meta[name="theme-color"]'), 'content', getComputedStyle(document.body).getPropertyValue('--ices-blue').trim());

    return () => {
      document.body.classList.remove('ices-student');
      restore.forEach((reset) => reset());
    };
  }, []);

  return children;
}
